import script from './Carousel.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel",class:_vm.screenSize},[_c('div',{ref:"carouselSlidesRef",staticClass:"carousel__slides"},[_vm._t("default")],2),_vm._v(" "),(!_vm.hideNavigation && _vm.numberOfSlides > 1)?_c('div',{staticClass:"carousel__navigation"},_vm._l((_vm.numberOfSlides),function(_,index){return _c('SdsCarouselDot',{key:index,attrs:{"isActive":index === _vm.activeSlideIndex},on:{"click":function($event){return _vm.scrollToSlide(index)}}})}),1):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-d860cf92_0", { source: ".carousel__slides[data-v-d860cf92]{display:flex;padding-block-end:12px;overflow-x:auto;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;-ms-overflow-style:none;scrollbar-width:none}.carousel__slides[data-v-d860cf92]::-webkit-scrollbar{display:none}.carousel__navigation[data-v-d860cf92]{display:none;justify-content:center;padding-block:11px 8px}@media only screen and (min-width:1280px){.dXs .carousel__slides[data-v-d860cf92]{scroll-snap-type:x mandatory;padding-block-end:0}.dXs .carousel__slides[data-v-d860cf92]:not(:has(+.carousel__navigation)){padding-block-end:12px}.dXs .carousel__navigation[data-v-d860cf92]{display:flex}.dXs .carousel__slide[data-v-d860cf92]{width:100%}}@media only screen and (min-width:769px){.tMd .carousel__slides[data-v-d860cf92]{scroll-snap-type:x mandatory;padding-block-end:0}.tMd .carousel__slides[data-v-d860cf92]:not(:has(+.carousel__navigation)){padding-block-end:12px}.tMd .carousel__navigation[data-v-d860cf92]{display:flex}.tMd .carousel__slide[data-v-d860cf92]{width:100%}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-d860cf92";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
